// extracted by mini-css-extract-plugin
export default {"formChild":"FormComp_formChild__oxzyK","invalid":"FormComp_invalid__+sLdE"};